import { makeBox, MakeBoxProps } from "../../layout";
import { ReactComponent as Default } from "./assets/LogoDefault.svg";
import { ReactComponent as GoStudent } from "./assets/LogoGoStudent.svg";
import { ReactComponent as GoStudentLearning } from "./assets/LogoGoStudentLearning.svg";
import { ReactComponent as IconOnly } from "./assets/LogoIconOnly.svg";
import { ReactComponent as Plurall } from "./assets/LogoPlurall.svg";
import { ReactComponent as PlurallSmile } from "./assets/LogoPlurallSmile.svg";

export type LogoVariant =
  | "default"
  | "goStudent"
  | "iconOnly"
  | "plurall"
  | "plurallSmile"
  | "goStudentLearning";

export const logoVariantMap: {
  [key in LogoVariant]: (props: MakeBoxProps) => JSX.Element;
} = {
  default: makeBox(Default),
  goStudent: makeBox(GoStudent),
  iconOnly: makeBox(IconOnly),
  plurall: makeBox(Plurall),
  plurallSmile: makeBox(PlurallSmile),
  goStudentLearning: makeBox(GoStudentLearning)
};

export const logoDescriptions: {
  [key in LogoVariant]: { description: string };
} = {
  default: {
    description: "Seneca logo"
  },
  goStudent: {
    description: "Seneca by Go Student logo"
  },
  iconOnly: {
    description: "Seneca logo"
  },
  plurall: {
    description: "Plurall logo"
  },
  plurallSmile: {
    description: "Plurall logo"
  },
  goStudentLearning: {
    description: "GoStudent Learning logo"
  }
};
